import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleNavigation = (path, hash) => {
    setMobileMenuOpen(false);
    if (path) {
      navigate(path);
    } else if (hash) {
      if (location.pathname !== '/') {
        navigate('/' + hash);
      }
    }
  };

  return (
    <>
      <header>
        <div className="header-container">
          <div className="logo" onClick={() => handleNavigation('/')} style={{ cursor: 'pointer' }}>
            <img src="https://shomal.ac.ir/wp-content/themes/main-shomal/assets/images/logo.png" alt="لوگوی دانشگاه شمال آمل" />
            <span className="logo-text">سامانه انجمن دانشگاه شمال آمل</span>
          </div>
          <nav>
            <ul>
              <li><a href="#home" onClick={(e) => { e.preventDefault(); handleNavigation(null, '#home'); }}>خانه</a></li>
              <li><a href="#about" onClick={(e) => { e.preventDefault(); handleNavigation(null, '#about'); }}>نامزدها</a></li>
              <li><a href="/voting" onClick={(e) => { e.preventDefault(); handleNavigation('/voting'); }}>رأی بده</a></li>
              <li><a href="#contact" onClick={(e) => { e.preventDefault(); handleNavigation(null, '#contact'); }}>تماس با ما</a></li>
            </ul>
          </nav>
          <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
            <i className="fas fa-bars"></i>
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <div className={`mobile-menu-overlay ${mobileMenuOpen ? 'active' : ''}`} onClick={toggleMobileMenu}></div>
      <div className={`mobile-menu ${mobileMenuOpen ? 'active' : ''}`}>
        <div className="mobile-menu-header">
          <div className="mobile-menu-logo">
            <img src="https://shomal.ac.ir/wp-content/themes/main-shomal/assets/images/logo.png" alt="لوگوی دانشگاه شمال آمل" />
            <span>خدمات و صفحات</span>
          </div>
          <button className="mobile-menu-close" onClick={toggleMobileMenu}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        <ul className="mobile-menu-nav">
          <li><a href="#home" onClick={(e) => { e.preventDefault(); handleNavigation(null, '#home'); }}>خانه</a></li>
          <li><a href="#about" onClick={(e) => { e.preventDefault(); handleNavigation(null, '#about'); }}>نامزدها</a></li>
          <li><a href="/voting" onClick={(e) => { e.preventDefault(); handleNavigation('/voting'); }}>رأی بده</a></li>
          <li><a href="#contact" onClick={(e) => { e.preventDefault(); handleNavigation(null, '#contact'); }}>تماس با ما</a></li>
        </ul>
      </div>
    </>
  );
};

export default Header;